// import http from '../http';

import AuthUser from './AuthUser';
import { useState } from 'react';


export default function Logout(){
    const {http,setToken} = AuthUser();
    const [email,setEmail]=useState();
    const [password,setPassword]=useState();

    const submitForm = ()=>{
        http.post('/login',{email:email,password:password}).then((res)=>{
            setToken(res.data.user,res.data.access_token)
        })
    }
    return (
        <div className='row justify-content-center pt-5'>
            <div className='col-sm-6'>
            <div className='card p-4'>
            <div className="form-group">
    <label for="email">Email address:</label>
    <input type="email" className="form-control" placeholder="Enter email" onChange={e=>setEmail(e.target.value)} id="email" />
  </div>
  <div className="form-group mt-3">
    <label for="pwd">Password:</label>
    <input type="password" className="form-control" placeholder="Enter password" onChange={e=>setPassword(e.target.value)} id="pwd" />
  </div>
  
  <button type="button" className="btn btn-primary mt-4" onClick={submitForm}>Submit</button>
  </div></div>
        </div>
    )
}